import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'SelectStoreDialog',
  components: {},
  mixins    : [DialogVisible, StoreCommon],
  props     : {
    stores: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods : {
    toLocaleUpperCase,
    onStoreSelected(store) {
      this.isVisible = false
      this.$emit('store:selected', store)
    },

    onCancelButtonClick() {
      this.isVisible = false
    }
  }
}
